import React, { useRef } from "react";
import cx from "classnames";
import { PillButton } from "./radioGroup.styles";

export const RadioInputWrapper = (props) => {
  const { checked, className, combined, children } = props;
  const ref = useRef();

  return (
    <PillButton role="radio" type="button" aria-checked={checked} className={cx(className, {combined})} onClick={() => ref.current.click()}>
      {children(ref)}
    </PillButton>
  );
}